export const refactoredData = (dataArray: any[]) => {
  const data = dataArray?.map((item: any) => ({
    id: item.id,
    invoiceId: item?.account_invoice_id?.id,
    name: item.name,
    date: item.date,
    state: item.state,
    memberPrice: item.member_price,
    invoiceName: item.account_invoice_id?.name || null,
    partnerName: item.partner?.name || null,
    membershipName: item.membership_id?.[1] || null,
    date_From: item?.date_from,
    date_to: item?.date_to,
    type: item?.membership_id?.[1],
  }))
  return data
}
export const stringToTitleCase = (str: string) => {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word: string) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
    ?.join(' ')
}
